import $ from 'jquery';
import { openModal } from './modal';

const $shareButton = $('.share-button');

if ($shareButton.length > 0) {
    $shareButton.each(function () {
        share($(this));
    });
}

function share(element) {
    const title = element.data('title');
    const url = element.data('url');

    element.on('click', function (enableNavigator = false) {
        if (navigator.share && enableNavigator === true) {
            navigator
                .share({
                    title: title,
                    url: url,
                })
                .catch(console.error);
        } else {
            openModal('#share-modal');
        }
    });
}
